import React from 'react';
import PropTypes from 'prop-types';
import {
  Avatar,
  Button,
  Grid,
  Typography,
  Container,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

const FormForgotPassword = ({ classes, isError, labelRef, labelWidth, username, onEmail, onSubmit, onChange }) => (
  <Container component="main" maxWidth="xs">
    <div className={classes.paper}>
      <Avatar className={classes.avatar}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        Recovery Password
      </Typography>
      <form className={classes.form} noValidate>
        <FormControl className={classes.formControl} variant="outlined" error={isError}>
          <InputLabel ref={labelRef} htmlFor="component-outlined">
            Email *
          </InputLabel>
          <OutlinedInput
            onBlur={onEmail}
            labelWidth={labelWidth}
            id="component-outlined"
            value={username}
            onChange={onChange('username')}
          />
          {isError && <FormHelperText id="component-error-text">Enter a valid email</FormHelperText>}
        </FormControl>
        <Button
          disabled={isError || !username}
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick={onSubmit}
        >
          Recovery Password
        </Button>
        <Grid container>
          <Grid item xs>
            <Link to="/login">Return to login</Link>
          </Grid>
        </Grid>
      </form>
    </div>
  </Container>
);

FormForgotPassword.propTypes = {
  labelWidth: PropTypes.number.isRequired,
  username: PropTypes.string.isRequired,
  isError: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  labelRef: PropTypes.object.isRequired,
  onEmail: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default FormForgotPassword;
